import { Component } from '@angular/core';

@Component({
  selector: 'app-fiber-categories',
  templateUrl: './fiber-categories.component.html',
  styleUrl: './fiber-categories.component.scss',
})
export class FiberCategoriesComponent {}
